(function () {
  const homeTl = gsap.timeline({
    defaults: {
      duration: 1.8,
      ease: 'expo.out',
    },
  });

  const titleSplitWrapper = new SplitText('.home-hero__title', {
    type: 'words',
    wordsClass: 'anim-line',
  });
  const titleSplit = new SplitText('.home-hero__title', {
    type: 'words',
  });

  homeTl
    .to('.home-hero__text', {
      autoAlpha: 1,
      duration: 0.1,
    })

    .fromTo(
      titleSplit.words,
      {
        yPercent: 100,
      },
      {
        yPercent: 0,
        stagger: 0.1,
      },
    );
})();
